import {defineMessages, FormattedMessage} from 'react-intl';

import {Action, css, Icon, Menu, MenuItem, Tooltip} from '@sail/ui';
import {overflow, support} from '@sail/icons/react/Icon';

import {useAnalytics} from '@stripe-internal/conversations-ui';

import {assignRequestNavigation} from './assignRequestNavigate';
import {useApp, useEntryPoint} from '../../../core/hooks/appHooks';

const messages = defineMessages({
  developerDocs: {
    id: 'conversations_assistant.header.developerDocs',
    description: 'Label for the developer docs link',
    defaultMessage: 'Developer docs',
  },
  supportArticles: {
    id: 'conversations_assistant.header.supportArticles',
    description: 'Label for the support articles link',
    defaultMessage: 'Support articles',
  },
  supportCenter: {
    id: 'conversations_assistant.header.supportCenter',
    description: 'Label for the support center link',
    defaultMessage: 'Support center',
  },
  restartConversation: {
    id: 'conversations_assistant.header.restartConversation',
    description: 'Label for restart conversation link',
    defaultMessage: 'Restart conversation',
  },
  minimizeTooltip: {
    id: 'conversations_assistant.header.minimizeTooltip',
    description: 'Label for the minimize botton',
    defaultMessage: 'Minimize',
  },
  closeTooltip: {
    id: 'conversations_assistant.header.closeTooltip',
    description: 'Label for the close botton',
    defaultMessage: 'Close',
  },
  moreTooltip: {
    id: 'conversations_assistant.header.moreTooltip',
    description: 'Label for the more botton',
    defaultMessage: 'More',
  },
});

const buttonStyles = css({
  display: 'inline-flex',
  borderRadius: 'rounded',
  padding: 'small',
  ':hover': {
    backgroundColor: 'offset',
  },
});

export function HeaderActions() {
  const app = useApp();
  const entryPoint = useEntryPoint();

  const analytics = useAnalytics();
  const isSupportSite = entryPoint === 'support_site';
  const isExpressSupport = entryPoint === 'express_support_site';
  const isDashboard = entryPoint === 'dashboard';

  return (
    <>
      {!isSupportSite && !isExpressSupport ? (
        <Menu
          trigger={
            <Tooltip
              type="label"
              trigger={
                <Action css={{padding: 'small'}} uses={[buttonStyles]}>
                  <Icon
                    icon={overflow}
                    size="xsmall"
                    data-testid="assistant-header-more-menu"
                  />
                </Action>
              }
            >
              <FormattedMessage {...messages.moreTooltip} />
            </Tooltip>
          }
        >
          <MenuItem
            href="https://docs.stripe.com/"
            target="stripe-docs"
            data-testid="assistant-header-stripe-docs-link"
            onAction={() => {
              analytics.action('stripe_assistant_header_stripe_docs_click');
            }}
          >
            <FormattedMessage {...messages.developerDocs} />
          </MenuItem>
          <MenuItem
            href="https://support.stripe.com/"
            target="stripe-articles"
            data-testid="assistant-header-stripe-articles-link"
            onAction={() => {
              analytics.action('stripe_assistant_header_stripe_articles_click');
            }}
          >
            <FormattedMessage {...messages.supportArticles} />
          </MenuItem>
          <MenuItem
            type="destructive"
            data-testid="assistant-header-stripe-restart-conversation"
            onAction={() => {
              app.restartConversation();
              analytics.action(
                'stripe_assistant_header_stripe_restart_conversation',
              );
            }}
          >
            <FormattedMessage {...messages.restartConversation} />
          </MenuItem>
        </Menu>
      ) : null}

      {isDashboard ? (
        <Tooltip
          type="label"
          trigger={
            <Action
              uses={[assignRequestNavigation(), buttonStyles]}
              onClick={() => {
                analytics.action(
                  'stripe_assistant_header_support_center_click',
                );
                app.requestAction({
                  action: {
                    name: 'navigate',
                    data: {
                      route: {name: 'SUPPORT'},
                    },
                  },
                });
              }}
            >
              <Icon
                icon={support}
                size="xsmall"
                data-testid="assistant-header-support-center-link"
              />
            </Action>
          }
        >
          <FormattedMessage {...messages.supportCenter} />
        </Tooltip>
      ) : null}
    </>
  );
}
